import { render, staticRenderFns } from "./teamreg.vue?vue&type=template&id=f7b6cdbc&scoped=true"
import script from "./teamreg.vue?vue&type=script&lang=js"
export * from "./teamreg.vue?vue&type=script&lang=js"
import style0 from "./teamreg.vue?vue&type=style&index=0&id=f7b6cdbc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7b6cdbc",
  null
  
)

export default component.exports